import React from 'react';
import ImportImages from '@src/importImages';
const Stephanie = ImportImages('/news/stephanie-news.jpg');
const JetSuiteRaises = ImportImages('/news/jetsuite-raises-the-bar.jpg');

export default [
  {
    slug: 'stephanie-chung-president-appointment-press-release',
    content: (
      <React.Fragment>
        <h1 className={'text-center font-md lakes-bold'}>
          JetSuite, Inc. Appoints Stephanie Chung as President of the
          Dallas-Based Private Jet Aviation Company
        </h1>
        <div className={'text-center font-sm lakes-medium pb-4'}>
          <i>
            The Seasoned Aviation Leader Takes the Helm of JetSuite, Inc. as the
            First African American And African American Female to Lead a Private
            Business Aviation Company
          </i>
        </div>
        <p>
          <img
            src={Stephanie}
            className={'float-left mr-3 mb-3'}
            alt={'Stephanie Chung'}
            style={{ maxWidth: '30%' }}
          />
          <strong>Dallas, Tex. (August 21, 2018)</strong> –{' '}
          <a href={'https://www.jetsuite.com'} className={'red-link'}>
            JetSuite, Inc.
          </a>
          , a leading innovator in private jet aviation, is delighted to
          announce the appointment of Stephanie Chung as President, effective
          immediately. An aviation veteran with more than 30 years of experience
          in commercial and business aviation, Chung will oversee all aspects of
          the company including sales, marketing, revenue management,
          performance, and guest services for the brand. This appointment makes
          Chung the first African American and African American female to lead a
          private business aviation company.
          <br />
          <br />
          Chung brings a wealth of knowledge to her new role with JetSuite, Inc.
          with proven expertise in sales, business development, and executive
          leadership within the private jet industry. Prior to assuming her role
          as President of JetSuite, Inc. she trained individuals and businesses
          around the world as an award-winning executive coach, sales mentor and
          business advisor. Backed by more than three decades of experience
          within Fortune 500 companies, Chung has mentored, coached and
          developed some of the highest paid, most elite sales professionals in
          the country – routinely collaborating with notable companies to coach
          and train sales teams on neuroscience selling and high-ticket-item
          selling. Most recently, Stephanie was engaged with the JetSuite, Inc.
          sales team in a consulting role.
        </p>
        <p>
          Stephanie started her aviation career in the 1980’s with Piedmont
          Airlines in Boston, and progressed through various roles at US
          Airways, before entering into private aviation where she served as
          Vice President of Sales, Western Region of Flexjet and oversaw and
          held various executive sales positions with Skyjet.
        </p>
        <p>
          “I am incredibly honored and proud to appoint Stephanie as President
          of JetSuite, Inc. and know that her expansive aviation knowledge and
          sales leadership will be a key asset for the company,” said Alex
          Wilcox, CEO of JetSuite and JetSuiteX. “We are thrilled to have
          Stephanie lead the JetSuite team as we enter the next phase of growth
          and our tenth year in operation.”
        </p>
        <p>
          Chung joins the JetSuite, Inc. team on the heels of major company
          announcements and milestones which include recent investments from
          JetBlue Airways and Qatar Airways which will help fuel the growth of
          JetSuite’s private aviation business; a launch customer partnership
          with Zunum Aero which will bring the first-ever hybrid-to-electric
          flights to the skies; and a first of its kind code share partnership
          between JetBlue Airways and JetSuite sister company JetSuiteX.
        </p>
        <p>
          Chung resides in Dallas and is an active member of several local
          committees including Elevation Society, Executive Women’s Roundtable
          and Texas Commission on Law Enforcement. She is the author of Profit
          Like a Girl, A Woman’s Guide to Kicking Butt in Sales and Leadership
          and creator of the High Ticket Selling Made Simple course and
          Neuroscience Selling.
        </p>
        <p className={'text-center'}>###</p>
        <p>
          <strong>About JetSuite, Inc.</strong>
          <br />
          <br />
          JetSuite provides flying that moves your soul through transparent
          pricing, efficient operations, acute attention to detail, acclaimed
          customer service, and industry-leading safety practices. Offering a
          WiFi-equipped fleet of jets across the US, JetSuite was recently
          ranked #1 in light jet utilization by ARGUS. Under the leadership of
          CEO Alex Wilcox, a JetBlue founding executive, JetSuite is IS-BAO
          certified and rated Platinum by ARGUS, the highest possible safety
          rating in the private jet industry. For information please visit{' '}
          <a className={'red-link'} href={'https://www.jetsuite.com'}>
            www.jetsuite.com
          </a>
          .
        </p>
      </React.Fragment>
    )
  },
  {
    slug: 'qatar-airways-announces-investment-in-jetsuite-inc',
    content: (
      <React.Fragment>
        <h1 className={'text-center font-md lakes-bold'}>
          QATARAIRWAYS ANNOUNCES INVESTMENT IN JETSUITE, INC.
        </h1>
        <div className={'text-center font-sm lakes-medium pb-4'}>
          <i>
            International aviation leader joins JetBlue Airways and private
            investors in fuelingthe future of private and semiprivate aviation
          </i>
        </div>
        <p>
          <strong>Washington, D.C. –April 10, 2018</strong> –QatarAirways, the
          national airline of the State ofQatarand one of the world’s
          fastest-growing airlines, andJetSuite, Inc., a leading U.S. private
          aviation company, announced today in the presence of theQatari
          Minister of Finance and Chairman ofQatarAirways, His Excellency Mr Ali
          Sharif Al Emadi thatQatarAirways has taken a minority stake in
          JetSuite, Inc. and indirectly in JetSuiteX, Inc.QatarAirways joins
          JetBlue Airways, which will be increasing its investment, and a number
          of private investors as stakeholders in both JetSuite and JetSuiteX.
        </p>
        <p>
          With this investment in JetSuite, Inc.,QatarAirways will help fuel the
          growth of JetSuite’s private aviation business, which currently
          focuses on light and very light jets. The investment extends to
          JetSuiteX, the sibling company to JetSuite, further accelerating the
          expansion of its acclaimed semi-private air service on the U.S. West
          Coast and beyond. JetSuiteX fills a niche in underserved short haul
          markets and small airports, and enjoys a Net Promoter Score over 90,
          higher than the major U.S. airlines. JetSuiteX operates its fleet of
          Embraer 135 aircraft from private terminals in California and Nevada,
          with no lines, no waiting and no stress, at a price competitive with
          commercial travel. TheQatarAirwaysinvestment will enable faster
          expansion of this fleet and the ability to reach new destinations,
          including the potential to bring the semi-private model to additional
          U.S. regions.
        </p>
        <p>
          QatarAirways Group Chief Executive, His Excellency Mr. Akbar Al Baker
          said, “We are delighted to have the opportunity to invest in such
          unique business as JetSuite and JetSuiteX; we believe that both
          businesses are complimentary toQatarAirways business and maintain the
          core values and customer focus of our own business.Webelieve that
          JetSuite and JetSuiteX deliver a truly class-leading service to the
          U.S. market with a huge potential for development, and we are very
          excited to invest in this opportunity alongside JetBlue and the other
          investors.”
        </p>
        <p>
          “As an innovator in private aviation, we are proud to have attracted
          the attention of one of the world’s highest rated and fastest growing
          airlines,” said Alex Wilcox, Founder and CEO of JetSuite and
          JetSuiteX. “QatarAirways shares our focus on customers and product.
          JetBlue andQatarAirways together are a dream team of investors, and
          they will allow us to execute our vision of offering a superior
          service to the forgotten short haul U.S. air market even more
          quickly.”
        </p>
        <p>
          “JetSuite’s innovative JetSuiteX service and customer-focused approach
          aligns perfectly with our values at JetBlue, which is why we are so
          pleased that our partners atQatarAirways are joining us in supporting
          this venture,” said Robin Hayes, President and CEO, JetBlue. “We look
          forward to seeing JetSuite further grow on the West Coast and beyond
          to bring additional air travel choices to customers in underserved
          markets.”
        </p>
        <p>
          This investment further supportsQatarAirways investment strategy,
          which already includes minority investments in several other
          international carriers, such as International Airlines Group, LATAM
          Airlines Group, Cathay Pacific and Air Italy.
        </p>
        <p>
          <strong>About JetSuite</strong>
          <br />
          JetSuite provides flying that moves your soul through transparent
          pricing, efficient operations, acute attention to detail, acclaimed
          customer service, and industry-leading safety practices. Offering a
          WiFi-equipped fleet of jets across the U.S., JetSuite was recently
          ranked #1 in light jet utilization by ARGUS. Under the leadership of
          CEO Alex Wilcox, a JetBlue founding executive, JetSuiteis IS-BAO
          certified and rated Platinum by ARGUS, the highest possible safety
          rating in the private jet industry. For information please visit{' '}
          <a href={'https://www.jetsuite.com'} className={'red-link'}>
            www.jetsuite.com
          </a>
          .
        </p>
        <p>
          <strong>About JetSuiteX</strong>
          <br />
          JetSuiteXbegan offering public charter service inApril 2016with
          regular flights between select West Coast markets. JetSuiteX provides
          the speed and comfort associated with private jet travel but for the
          price of a traditional airline seat, including:
          <ul className={'pl-3 mb-1'}>
            <li>
              Flight departures from private jet terminals so the experience is
              faster and more comfortable, with no airport terminal delays,
              security lines, waiting for gates or long walks through terminals;
            </li>
            <li>
              30-seat regional jets, each with legroom comparable to domestic
              airlines' business class service;
            </li>
            <li>Free seat assignments, with power at every seat;</li>
            <li>
              A spacious, soundproofed cabin interior covered in soft leather,
              and
            </li>
            <li>Free drinks and snacks.</li>
          </ul>
          JetSuiteX'sluxuriously appointed E-135 jets can also be chartered for
          group trips, corporate events or other travel. For a custom quote,
          contact JetSuiteX at 800-IFlyJSX. For information, please visit{' '}
          <a href={'https://www.jetsuitex.com'} className={'red-link'}>
            www.JetSuiteX.com
          </a>
        </p>
        <p>
          JetSuite and JetSuiteX Public Relations
          <br />
          Tel: +1-949-892-4327
          <br />
          <a href="mailto:press@jetsuite.com" className={'red-link'}>
            press@jetsuite.com
          </a>
        </p>
        <p>
          <strong>About JetBlue Airways</strong>
          <br />
          JetBlue is New York's Hometown Airline, and a leading carrier in
          Boston, Fort Lauderdale - Hollywood, Los Angeles (Long Beach),
          Orlando, and San Juan. JetBlue carries more than 40 million customers
          a year to 101 cities in the U.S., Caribbean, and Latin America with an
          average of 1,000 daily flights. For more information, please visit{' '}
          <a href="https://www.jetblue.com" className={'red-link'}>
            www.jetblue.com
          </a>
          .
        </p>
        <p>
          JetBlue Corporate Communications
          <br />
          Tel: +1-718-709-3089
          <br />
          <a href="mailto:corpcomm@jetblue.com" className={'red-link'}>
            corpcomm@jetblue.com
          </a>
        </p>
        <p>
          <strong>About Qatar Airways</strong>
          Qatar Airways, the national carrier of the State of Qatar, is
          celebrating more than 20 years of Going Places Together with
          travellers across its more than 150 business and leisure destinations.
          The world’s fastest-growing airline will add a number of exciting new
          destinations to its growing network in 2018, including Thessaloniki,
          Greece; Cardiff, UK and many more, flying passengers on board its
          modern fleet of more than 200 aircraft.
        </p>
        <p>
          A multiple award-winning airline, Qatar Airways was named ‘Airline of
          the Year’ by the 2017 World Airline Awards, managed by international
          air transport rating organisation Skytrax. It was also named ‘World’s
          Best Business Class,’ ‘Best Airline in the Middle East,’ and ‘World’s
          Best First Class Airline Lounge.’
        </p>
        <p>
          Qatar Airways is a member of the oneworld global alliance. The
          award-winning alliance was named the World’s Best Airline Alliance
          2015 by Skytrax for the third year running. Qatar Airways was the
          first Gulf carrier to join global airline alliance, oneworld, enabling
          its passengers to benefit from more than 1,000 airports in more than
          150 countries, with 14,250 daily departures.
        </p>
        <p>
          Oryx One, Qatar Airways’ in-flight entertainment system offers
          passengers up to 4,000 entertainment options from the latest
          blockbuster movies, TV box sets, music, games and much more.
          Passengers flying on Qatar Airways flights served by its B787, A350,
          A380, A319 and select A320 and A330 aircraft can also stay in touch
          with their friends and family around the world by using the
          award-winning airline’s onboard Wi-Fi and GSM service.
        </p>
        <p>
          Qatar Airways proudly supports a range of exciting international and
          local initiatives dedicated to enriching the global community that it
          serves. Qatar Airways, the official FIFA partner, is the official
          sponsor of many top-level sporting events, including the FIFA 2018 and
          2022 World Cups, reflecting the values of sports as a means of
          bringing people together, something at the core of the airline’s own
          brand message - Going Places Together.
        </p>
        <p>
          Qatar Airways Cargo, the world’s third largest international cargo
          carrier, serves more than 60 exclusive freighter destinations
          worldwide via its world-class Doha hub and also delivers freight to
          more than 150 key business and leisure destinations globally with more
          than 200 aircraft. The Qatar Airways Cargo fleet includes eight Airbus
          A330 freighters, 13 Boeing 777 freighters and two Boeing 747-8
          freighters.
        </p>
        <p>
          For further information, please contact:
          <br />
          Qatar Airways Group, Corporate Communications Department
          <br />
          Tel: +974 4022 2200
        </p>
      </React.Fragment>
    )
  },
  {
    slug: 'leading-light-jet-operator-jetsuite-inc-celebrate-10-years',
    content: (
      <React.Fragment>
        <h1 className={'text-center font-md lakes-bold'}>
          Leading Light Jet Operator, JetSuite, Inc., Celebrates 10 Years Of
          Continuous Operation In 2019
        </h1>
        <div className={'text-center font-sm lakes-medium pb-4'}>
          <i>
            Company Marks Major Private Aviation Milestone with Fleet Expansion
            and Elevated Passenger Experiences
          </i>
        </div>

        <p>
          <strong>DALLAS – January 10, 2019 -</strong>{' '}
          <a href={'https://www.jetsuite.com'} className={'red-link'}>
            JetSuite, Inc.
          </a>{' '}
          is pleased to announce that it will celebrate its tenth year of
          operation in 2019, as the first and only premium experience in the
          light jet category. Delivering flying experiences that move the soul,
          JetSuite is an industry-leader providing individualized service,
          distinctive amenities, a fleet of state-of-the-art jets, and the
          friendliest, most knowledgeable pilots in the industry.
        </p>
        <p>
          Moving into this landmark year, JetSuite is looking ahead to the
          arrival of new aircraft joining its fleet, enabling the company to
          offer a wider array of private aviation solutions. JetSuite is also
          elevating the overall passenger experience through the introduction of
          luxurious in-cabin amenities from world-renowned brands, deepening its
          commitment to infusing every trip with the spirit of hospitality.
        </p>
        <p>
          “We are proud that in the highly competitive world of private
          aviation, JetSuite now stands as one of very few operators to achieve
          this ten-year milestone,” said Alex Wilcox, Founder & CEO, JetSuite,
          Inc. “Since day one, JetSuite has been deeply committed to bringing
          innovation to private aviation and maintaining the best customer
          experience in the industry. As a result, we are well-positioned for
          significant growth as we enter our second decade.”
        </p>
        <p>
          JetSuite’s current fleet consists of the Embraer Phenom 100 and 300
          aircraft and the company has flown more hours to-date on these
          aircraft than any other operator in the world. Fueled by investments
          from Qatar Airways and JetBlue, the company is preparing to add
          additional, larger aircraft to its fleet in mid-2019 that will provide
          a greater range of options for JetSuite clients.
        </p>
        <p>
          Further enhancing the passenger experience, JetSuite has unveiled a
          collection of amenities curated in partnership with leading luxury
          brands. From a signature cabin scent by Paris-based fragrance house{' '}
          <strong>Diptyque</strong> and <strong>Venus et Fleur’s</strong>{' '}
          Eternity Roses on every flight to vegan and cruelty-free{' '}
          <strong>Red Flower</strong> amenity kits, a new line of onboard snacks
          curated by gourmet foods purveyor <strong>Torn Ranch</strong> to
          luxurious and sustainable JetSuite-branded blankets by Coyuchi,
          JetSuite has hand-selected partners who epitomize luxury,
          sustainability, and relevance. Ensuring every traveler is equally
          pampered, JetSuite has also partnered with{' '}
          <strong>For the Furry</strong> to offer customized amenities for
          passengers’ four-legged friends. JetSuite will continue to innovate
          and evolve these offerings with the announcement of additional
          partnerships throughout the year.
        </p>
        <p>
          “Approaching this landmark anniversary, we have taken a closer look at
          what our customers love about JetSuite as well as how we can better
          serve their private aviation needs. Beyond our track record for
          exemplary customer service and the expertise of our pilots, we took a
          close look at how we can infuse thoughtful and luxurious touches to
          further elevate the JetSuite experience,” said Stephanie Chung,
          President of JetSuite. “In the coming months, we will reaffirm our
          position as a leading private jet operator, adding new aircraft to our
          fleet while elevating every single customer touchpoint to take
          JetSuite to new heights.”
        </p>
        <p>
          Coinciding with changes being made to the products and services,
          JetSuite has refreshed its SuiteKey membership program, providing
          clients with preferred, fixed hourly rates, no repositioning fees,
          365-day access, and guaranteed availability with 48 hours’ notice.
          Clients simply deposit at the Chairman, Founder, or Executive levels
          and fly against those funds, starting at $100,000. SuiteKey members
          also have access to exclusive events and offers from JetSuite’s
          partners. For those who fly less frequently, JetSuite will continue to
          offer on-demand charter services. Regardless of how customers choose
          to fly, they have access to JetSuite’s guest services team via phone
          and email.
        </p>
        <p>
          <strong>About JetSuite</strong>
        </p>
        <p>
          Celebrating its tenth year of operation in 2019, JetSuite is a leader
          in private aviation, providing flying that moves the soul through
          individualized service, distinctive amenities, a fleet of
          state-of-the-art jets, and the friendliest and most knowledgeable
          pilots in the industry.
        </p>
        <p>
          JetSuite was ranked number one in more categories than any other
          company in Business Jet Traveler’s 8th Annual Readers’ Choice Survey
          in 2018, taking the top spot for customer service.
        </p>
        <p>
          Safety is paramount and JetSuite is ARG/US PLATINUM, the highest
          rating achievable in civil aviation, and an accolade bestowed on fewer
          than 5% of charter operators nationwide.
        </p>
        <p>
          JetSuite is dedicated to a better way forward, moving people — and the
          industry — into new, uncharted territories. It's where the spirit of
          hospitality takes flight.
        </p>
        <p>
          For information please visit{' '}
          <a className={'red-link'} href={'https://www.jetsuite.com'}>
            www.jetsuite.com
          </a>
          .
        </p>
        <p className={'text-center'}># # #</p>
      </React.Fragment>
    )
  },
  {
    slug: 'jetsuite-raises-the-bar-for-personalized-luxury-travel',
    content: (
      <React.Fragment>
        <h1 className={'text-center font-md lakes-bold'}>
          JETSUITE RAISES THE BAR FOR PERSONALIZED LUXURY TRAVEL
          WITHFIRST-OF-ITS-KIND PARTNERSHIP: “JETSUITE EXPERIENCES” BY EMBARK
        </h1>
        <div className={'py-2 text-center'}>
          <img
            src={JetSuiteRaises}
            className={'img-fluid'}
            alt={'JETSUITE RAISES THE BAR FOR PERSONALIZED LUXURY TRAVEL'}
          />
        </div>
        <p>
          <strong>DALLAS, Texas – May 2, 2019</strong> –{' '}
          <a href={'https://www.jetsuite.com'} className={'red-link'}>
            JetSuite, Inc.
          </a>{' '}
          announced todaythat it has partnered with luxury travel company Embark
          to launch “JetSuite Experiences.” A first in business aviation, this
          strategic luxury and travel services partnership is dedicated to
          creating thoughtfully-designed experiences that go beyond a
          destination.
        </p>
        <p>
          Further enhancingits best-in-class private aviation services, the new
          partnership with Embark underscores JetSuite’s commitment to
          infuseevery trip with the spirit of hospitality and signals yet
          another way the brand is celebrating its ten years of continuous
          operation in 2019.
        </p>
        <p>
          “Today’s luxury travelers are looking for exceptional, insider
          experiences that start the moment they step on board to the moment
          they return home and everything in between. There is nothing cookie
          cutter about how and why our clients travel,” saidStephanie Chung,
          President of JetSuite. “Whether it’s a reward for hard work, to
          strengthen a bond with someone they love, or to feel a sense of
          adventure, our partnership with Embark allows us to personallycurate
          each itinerary based on each client’s specific tastes, preferences,
          andto cater to their underlyingmotivation for taking the trip.”
        </p>
        <p>
          Founded by Jack Ezon, Embark is a new concept in the luxury travel and
          lifestyle space dedicated to creating thoughtfully-designed trips.
          Drawing on its vast global network of contacts, deep luxury and in
          market expertise, and unparalleled access to one-of-a-kind
          experiences, Embark can help JetSuite clients coordinate everything
          from simple weekend getaways and upgrades to premium suites to access
          to the most sought-after eventsto complement their first-class flight
          experiences on JetSuite’s Phenom 100s, Phenom 300s, and Legacy 650.
        </p>
        <p>
          “We are excited to be partnering with the premier private aviation
          company in the country to extend our high-touch, out-of-the-box
          concierge services to JetSuite flyers, inspiring them with meaningful
          and memorable personal experiencesthat will enhance their ‘return on
          life,’” said Jack Ezon, Founder and Managing Partner of Embark.
        </p>
        <p>
          While each JetSuite Experience by Embark will be fully customized,
          clients can visit the JetSuite website to browse sample itineraries
          ranging from acozystay at The Ritz-Carlton, Half Moon Bayalong
          Northern California’s rugged coastline to a stayat Miami’sEdition
          Hotel–one of the most head-turning properties in this vibrant beach
          city.Clients can soak in the vibrancy of the city that never sleeps
          atThe Crosby, one of New York City’s stylish and whimsical
          destinationsor experience Toronto’s buzzing late-night scene at The
          Ritz-Carlton, Toronto.
        </p>
        <p>
          Further enhancing the passenger experience, JetSuitehas unveiled a
          collection of amenities curated in partnership with leading luxury
          brands. From a signature cabin scent by Paris-based fragrance house
          Diptyque and Venus et Fleur’s Eternity Roses on every flight to vegan
          and cruelty-free Red Flower amenitykits, a new line of onboard snacks
          curated by gourmet foods purveyor Torn Ranch to luxurious and
          sustainable JetSuite-branded blankets by Coyuchi. JetSuite has
          hand-selected partners who epitomize luxury, sustainability, and
          relevance. Ensuring every traveler is equally pampered, JetSuite has
          also partnered with For the Furry to offer customized amenities for
          passengers’ four-legged friends.
        </p>
        <p>
          <strong>About JetSuite</strong>
          <br />
          Celebrating its tenth year of operation in 2019, JetSuiteis a leader
          in private aviation, providing flying that moves the soul through
          individualized service, distinctive amenities, a fleet of
          state-of-the-art jets, and the friendliest and most knowledgeable
          pilots in the industry.JetSuite was ranked number one in more
          categories than any other company in Business Jet Traveler’s 8th
          Annual Readers’ Choice Survey in 2018, taking the top spot for
          customer service. Safety is paramount and JetSuite is ARG/US PLATINUM,
          the highest rating achievable in civil aviation, and an accolade
          bestowed on fewer than 5% of charter operators nationwide. JetSuite is
          dedicated to a better way forward, moving people —and the industry
          —into new, uncharted territories. It's where the spirit of hospitality
          takes flight.For information please visit{' '}
          <a href={'https://www.jetsuite.com'} className={'red-link'}>
            www.jetsuite.com
          </a>
        </p>
        <p>
          <strong>About Embark</strong>
          <br />
          Embark is an international luxury travel and lifestyle partnership
          group, attracting the very best forward-thinking talent through shared
          ownership. This cutting-edge concept in the luxury lifestyle space has
          helped the company launch with over $100 million in sales to a
          sharply-focused, highly confidential black book of ultra-high net
          worth clients composed mostly of Gen-X and Millennial A-list
          celebrities, sports stars, Fortune 500 executives, dynamic financiers,
          entrepreneurs and real estate moguls around the world. Not only does
          the company pride itself of creating tailored, meaningful global
          experiences for individuals, it also hosts the largest luxury social
          destination event businesses in the Americas. Embark’s platform
          encourages synergies amongst partners touching an UHNWI’s life with
          expert advisors specializing in an individual’s preferences, passions,
          life goals and legacy.
        </p>
        <p className={'text-center'}>###</p>
      </React.Fragment>
    )
  },
  {
    slug:
      'jetsuite-and-jsx-earn-perfect-score-in-2020-corporate-quality-index-ranking',
    content: (
      <React.Fragment>
        <h1 className={'text-center font-md lakes-bold'}>
          JETSUITE AND JSX EARN TOP MARKS IN 2020 CORPORATE EQUALITY INDEX
        </h1>
        <div className={'text-center font-sm lakes-medium pb-4'}>
          <i>
            The Seasoned Aviation Leader Takes the Helm of JetSuite, Inc. as the
            First African American And African American Female to Lead a Private
            Business Aviation Company
          </i>
        </div>
        <p>
          <strong>DALLAS, TX -January 21, 2020 – </strong>
          Aviation companies JetSuite, a leading private charter operator, and
          JSX, a hop-on jet service revolutionizing short haul travel with daily
          flights from private terminals, proudly announced that they received a
          score of 100 percent on the Human Rights Campaign Foundation’s{' '}
          <a className={'red-link'} href={'http://hrc.org/cei'}>
            2020 Corporate Equality Index (CEI)
          </a>
          , the nation’s premier benchmarking survey and report measuring
          corporate policies and practices related to LGBTQ workplace equality.
        </p>
        <p>
          “Receiving a perfect score for our LGBTQ inclusive workplace policies,
          practices and benefits from the Human Rights Campaign Foundation’s
          2020 Corporate Equality Index is one of the great honors of my 30+
          year career in aviation” stated Alex Wilcox, CEO of JetSuite and JSX.
          “We are always looking for passionate individuals from varied
          backgrounds to join our team, and we believe thatour dedication to
          diversity and inclusion makes us well-rounded leaders in aviation and
          provides us with a distinct advantage in serving our diverse
          customers.”
        </p>
        <p>
          The results of this year’s CEI showcase how 1059 U.S.-based companies
          are not only promoting LGBTQ-friendly workplace policies in the U.S.,
          but helping advance the cause of LGBTQ inclusion in workplaces abroad.
          JetSuite and JSX’s efforts in satisfying all of the CEI’s criteria
          earned a 100 percent ranking and the designation as a{' '}
          <i>Best Place to Workfor LGBTQ Equality.</i>
        </p>
        <p>
          “Traditionally, our industry has been slow to appreciate the
          differences that unite both our crewmembers and our customer base,”
          added Kevin Horan, Vice President of Corporate Soul.“I am proud to be
          part of two exemplary brands, whichfoster an inclusive work
          environment that not only respects, but values all crew members
          equally.”
        </p>
        <p>
          JetSuite’s President, Stephanie Chung, who spoke at The National Gay
          Pilots Association (NGPA) Industry Expo in 2019, commended the
          organization’s efforts and affirmed the companies’ dedication to LGBTQ
          representation in the workplace, stating, “on behalf of JetSuite and
          JSX, we are so proud to stand here with you, to support you and to run
          alongside you.”
        </p>
        <p>
          The CEI rates companies and top law firms on detailed criteria falling
          under five broad categories:
          <ul>
            <li>Non-discrimination policies</li>
            <li>Employment benefits</li>
            <li>
              Demonstrated organizational competency and accountability around
              LGBTQ diversity and inclusion
            </li>
            <li>Public commitment to LGBTQ equality</li>
            <li>Responsible citizenship</li>
          </ul>
          The full report, is available online a{' '}
          <a href={'http://www.hrc.org/cei'} className={'red-link'}>
            http://www.hrc.org/cei.
          </a>
        </p>
        <p>
          <strong>ABOUT JETSUITE</strong>
          <br />
          <br />
          Celebrating over ten years of operation in 2020, JetSuite is a leader
          in private aviation, providing flying that moves the soul through
          individualized service, distinctive amenities, a fleet of
          state-of-the-art jets, and the friendliest and most knowledgeable
          pilots in the industry. JetSuite was ranked number one in more
          categories than any other company in Business Jet Traveler’s 8th
          Annual Readers’ Choice Survey in 2018, taking the top spot for
          customer service. Safety is paramount and JetSuite is ARG/US PLATINUM,
          the highest rating achievable in civil aviation, and an accolade
          bestowed on fewer than 5% of charter operators nationwide. JetSuite is
          dedicated to a better way forward, moving people —and the industry
          —into new, uncharted territories. It's where the spirit of hospitality
          takes flight. For information please visit{' '}
          <a className={'red-link'} href={'https://www.jetsuite.com'}>
            www.jetsuite.com
          </a>
          .
        </p>
        <p>
          <strong>ABOUT JSX</strong>
          <br />
          <br />
          Founded in 2016, JSX is a hop-on jet service that’s faster on the
          ground, more comfortable in the air and competitively priced with
          flights starting from $89 each way. JSX flies more than 2,000 monthly
          flights and focuses on connecting highly desirable business and
          leisure markets within 500 miles which means customers can save up to
          two hours each time they fly by avoiding crowded airports and long
          drives. JSX offers many industry-leading features including:
          <ul>
            <li>
              Arrive just 20 minutes before the flight from private jet
              terminals with no long check-in lines or waiting at crowded gates;
            </li>
            <li>A quick, effortless security screening process;</li>
            <li>
              A bright, spacious, modern cabin interior, featuring:
              <ul>
                <li>
                  30 comfortable leather seats, each with legroom comparable to
                  domestic airlines' first-class service;
                </li>
                <li>
                  Power outlets at every row; (high-speed internet service is
                  set to launch in 2020);
                </li>
              </ul>
            </li>
            <li>
              Free amenities for all customers including two checked bags,
              drinks, snacks, and complimentary cocktails inflight;
            </li>
            <li>
              Small dogs and cats permitted to fly under seat at no charge and
              medium or large sized dogs can fly in cabin at the cost of a
              regular ticket.
            </li>
            <li>Deplaning and baggage retrieval within minutes of arrival.</li>
          </ul>
          JSX flights may be booked directly through{' '}
          <a className={'red-link'} href={'https://www.jsx.com'}>
            www.jsx.com
          </a>{' '}
          or through codeshare partner JetBlue on multiple online travel sites.
          TrueBlue members may earn points on JSX flights.
        </p>
        <p>
          JSX’s updated Embraer 135 and 145 jets may also be chartered for group
          trips, corporate events or other travel. For a custom quote, contact
          800-iFLYJSX.
        </p>
        <p>
          <strong>ABOUT HUMAN RIGHTS CAMPAIGN FOUNDATION</strong>
          <br />
          <br />
          The Human Rights Campaign Foundation is the educational arm of
          America's largest civil rights organization working to achieve
          equality for lesbian, gay, bisexual transgender and queer people. HRC
          envisions a world where LGBTQ people are embraced as full members of
          society at home, at work and in every community.
        </p>
        <p className={'text-center'}>###</p>
      </React.Fragment>
    )
  }
];



// WEBPACK FOOTER //
// ./src/components/News/individualNews.jsx